var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicantInfoSentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20897"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 21043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6953 15.752C10.6953 13.5145 12.5091 11.7007 14.7466 11.7007C16.9841 11.7007 18.7979 13.5145 18.7979 15.752C18.7979 17.9895 16.9841 19.8033 14.7466 19.8033C12.5091 19.8033 10.6953 17.9895 10.6953 15.752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3721 21.3332C11.4816 20.8516 12.9373 20.7036 14.7464 20.7036C16.5571 20.7036 18.0139 20.8519 19.1237 21.3345C20.3327 21.8602 21.0675 22.7556 21.4527 24.0199C21.6332 24.6125 21.1881 25.205 20.5747 25.205H8.91979C8.30569 25.205 7.85965 24.6116 8.04071 24.0179C8.42637 22.7535 9.1623 21.8583 10.3721 21.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.1633 9.02671C26.1313 8.9986 26.0857 8.99208 26.047 9.01001L19.0623 12.2553C19.0247 12.2728 19.0005 12.3103 19 12.3518C18.9996 12.3932 19.023 12.4313 19.0602 12.4495L21.0369 13.4196C21.0731 13.4374 21.1164 13.4334 21.1487 13.4092L23.0706 11.9728L21.5618 13.5247C21.5403 13.5468 21.5293 13.5772 21.5317 13.6079L21.6819 15.5643C21.6853 15.6077 21.7143 15.6447 21.7556 15.6583C21.7667 15.6619 21.778 15.6637 21.7892 15.6637C21.82 15.6637 21.8499 15.6505 21.8707 15.6264L22.9199 14.4106L24.2168 15.0303C24.245 15.0438 24.2776 15.0443 24.3062 15.0319C24.3348 15.0194 24.3566 14.9952 24.3659 14.9654L26.195 9.13986C26.2078 9.09918 26.1954 9.05482 26.1633 9.02671Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantInfoSentLogo);
export default __webpack_public_path__ + "static/media/ApplicantInfoSentLogo.0be1d2f109d74a2e717ce43d07b62449.svg";
export { ForwardRef as ReactComponent };